"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getNetworkInformation = _interopRequireDefault(require("../utilities/getNetworkInformation"));

var _isLowEndDevice = _interopRequireDefault(require("../utilities/isLowEndDevice"));

var _isLowEndExperience = _interopRequireDefault(require("../utilities/isLowEndExperience"));

/**
 * A plugin responsible for collection information from the Navigator API.
 *
 * This plugin adds the following parameters to the beacon:
 *
 * - [`deviceMemory`][1]: The approximate amount of device memory in gigabytes.
 * - `effectiveNetworkType`: The effective connection type determined using
 *   a combination of recently observed rtt and downlink values.
 * - `effectiveNetworkBandwidth`: The effective connection bandwidth estimate
 *   in megabits per second
 * - [`hardwareConcurrency`][2]: The number of logical processors available to
 *   run threads on the user's computer.
 * - `isLowEndDevice`: A combination of the score of RAM and CPU.
 * - `isLowEndExperience`: A combination of the score of RAM, CPU, network
 *   status and saved data preferences.
 * - [`userAgent`][3]: the user agent string for the current browser.
 *
 * [1]: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/deviceMemory
 * [2]: https://developer.mozilla.org/en-US/docs/Web/API/NavigatorConcurrentHardware/hardwareConcurrency
 * [3]: https://developer.mozilla.org/en-US/docs/Web/API/NavigatorID/userAgent
 */
var createNavigatorPlugin = function createNavigatorPlugin() {
  return function (_ref) {
    var addVariable = _ref.addVariable,
        sendBeacon = _ref.sendBeacon;
    var connection = (0, _getNetworkInformation.default)();
    addVariable('deviceMemory', navigator.deviceMemory, true);
    addVariable('hardwareConcurrency', navigator.hardwareConcurrency, true);
    addVariable('isLowEndDevice', (0, _isLowEndDevice.default)(), true);
    addVariable('isLowEndExperience', (0, _isLowEndExperience.default)(), true);
    addVariable('userAgent', navigator.userAgent, true);

    if (connection != null) {
      addVariable('effectiveNetworkType', connection.effectiveType, true);
      addVariable('effectiveNetworkBandwidth', connection.downlink, true);
    }

    sendBeacon();
  };
};

var _default = createNavigatorPlugin;
exports.default = _default;